<template>
  <div class="contract-delete-modal py-3 px-8">
    <div class="text md:max-w-xs mb-5 text-center">
      Are you sure you want to delete this contract?
    </div>
    <div class="buttons-container text-center">
      <bdg-button class="mr-3" @click.native="closeModal">Cancel</bdg-button>
      <bdg-button @click.native="deleteContract">Delete</bdg-button>
    </div>
  </div>
</template>

<script>
import BdgButton from "../../elements/BdgButton";
export default {
  name: "ContractDeleteModal",
  components: { BdgButton },
  props: {
    id: { type: Number, required: true }
  },
  methods: {
    closeModal() {
      this.$store.commit("resetConfirmationModalParams");
    },
    deleteContract() {
      // API deletion request goes here
      console.log(`delete contract ${this.id}`);
    }
  }
};
</script>

<style scoped></style>
